/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { NonDeletedCommentReply } from './NonDeletedCommentReply';
import { User } from './User';
const ExtendedNonDeletedCommentReplyParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['author', /* #__PURE__ */ parsers.maybeNull(User)],
]), NonDeletedCommentReply);
export class ExtendedNonDeletedCommentReply extends NonDeletedCommentReply {
    static decode(input) {
        return ExtendedNonDeletedCommentReplyParser.decode(input).map(res => new ExtendedNonDeletedCommentReply(res));
    }
    static unsafeDecode(input) {
        return ExtendedNonDeletedCommentReply.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ExtendedNonDeletedCommentReplyParser.encode(data);
    }
    static schema() {
        return ExtendedNonDeletedCommentReplyParser.schema();
    }
}
